import { Controller } from "@hotwired/stimulus"

// Shows a required reason field when total_trees value changes from its original value.
// data-controller="tree-population-reason"
// data-tree-population-reason-original-value="100"
export default class extends Controller {
  static targets = ["input", "reasonField"]
  static values = { original: Number }

  connect() {
    this.toggle()
  }

  toggle() {
    const currentValue = parseInt(this.inputTarget.value, 10)
    const changed = !isNaN(currentValue) && currentValue !== this.originalValue

    this.reasonFieldTarget.classList.toggle("hidden", !changed)

    // Toggle required attribute on the input inside reasonField
    const reasonInput = this.reasonFieldTarget.querySelector("input, textarea")
    if (reasonInput) {
      reasonInput.required = changed
    }
  }
}
